import ToTop from './totop.vue'
export default ToTop